import http from 'plugins/axios';

export default {
  //模板下载
  templateDownload(){
    return http.get({
      url:`/la/admin/airdrop/record/excel`,
      responseType: 'blob'
    })
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/list'
    });
  },
  createTask(data) {
    return http.post({
      url: '/la/admin/airdrop/task/create',
      data,
      dataType: 'form'
    });
  },
  updateTask(data) {
    return http.post({
      url: '/la/admin/airdrop/task/update',
      data,
      dataType: 'form'
    });
  },
  removeTask(id) {
    return http.post({
      url: '/la/admin/airdrop/task/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  executeTask({id,googleCode}) {
    return http.post({
      url: '/la/admin/airdrop/task/execute',
      data: {
        id,googleCode
      },
      dataType: 'form'
    });
  },
  listTasks(data) {
    return http.get({
      url: '/la/admin/airdrop/task/list',
      data
    });
  },
  getTaskDetail(id) {
    return http.get({
      url: '/la/admin/airdrop/task/detail',
      data: {
        id
      }
    });
  },
  listRecords(data) {
    return http.get({
      url: '/la/admin/airdrop/record/list',
      data
    });
  },
  billTask(data) {
    return http.post({
      url: '/la/admin/airdrop/record/execute',
      data,
      dataType: 'form'
    });
  },
  executeRecord({id,googleCode}) {
    return http.post({
      url: '/la/admin/airdrop/record/execute',
      data: {
        id,googleCode
      },
      dataType: 'form'
    });
  },
  executeAllRecords(taskId) {
    return http.post({
      url: '/la/admin/airdrop/record/execute/all',
      data: {
        taskId
      },
      dataType: 'form'
    });
  },
  removeRecord(id) {
    return http.post({
      url: '/la/admin/airdrop/record/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  createRecord(data) {
    return http.post({
      url: '/la/admin/airdrop/record/create',
      data,
      dataType: 'form'
    });
  }
};
